   //   <Link
                //   className="anchor"
                //   // activeStyle={{backgroundColor:"black",}}
                //   // activeClass="active"
                //   to={item.link}
                //   // spy={true}
                //   smooth={true}
                //   offset={-50}
                //   duration={500}
                // >
                //   {item.name}
                // </Link>

export const data = [
    {
      id: 1,
      name:"Budget Deals",
      link: 'budgetdeals',
    },
    {
      id: 2,
      name:"Bbq Platters",
      link: 'bbqplatters',
    },
    {
      id: 3,
      name:"Popular",
      link: 'popular',
    },
    {
      id: 4,
      name:"Treat Boxes",
      link: 'treat',
    },
    {
      id: 5,
      name:"Burgers 1",
      link: 'burgers1',
    },
    {
      id: 6,
      name:"Burgers 2",
      link: 'burgers2',
    },
    {
      id: 7,
      name:"Burgers 3",
      link: 'burgers3',
    }
    ,
    {
      id: 8,
      name:"Extras",
      link: 'extras',
    }
  ];
  